import React from 'react';
import '../../../../components/commonComponents/broadcastoverview/broadcast.css';
import { Alert } from 'antd';

import { campaignBroadcastList } from '../../../../constant/app/campaign/campaign';

const SegmentOverview = ({ segment }) => {
  const segments = segment?.settings;
  const campaignEvaluationType = segment?.settings?.campaign_goal_evaluation_type;

  const getStatusCount = (item) => {
    switch (item?.title) {
      case 'Contact':
        return segments?.audience_count || 0;
      case 'Delivered':
        return segments?.delivered_count || 0;
      case 'Opened':
        return segments?.opened_count || 0;
      case 'Lead':
        return segments?.leads_count || 0;
      case 'Clicks':
        return segments?.clicks_count || 0;
      case 'Total Sales Amount':
        return segments?.total_sales_amount || 0;
      case 'Total Sales Count':
        return segments?.total_sales_count || 0;
      default:
        return 0;
    }
  };

  // Filter the broadcast list based on campaignEvaluationType
  const filteredBroadcastList = campaignBroadcastList?.filter((item) => {
    if (campaignEvaluationType === 'amount') {
      // Remove Lead, Clicks, and Total Sales Count for 'amount' type
      return !['Lead', 'Clicks', 'Total Sales Count'].includes(item.title);
    }

    if (campaignEvaluationType === 'volume') {
      // Remove Lead, Clicks, and Total Sales Amount for 'volume' type
      return !['Lead', 'Clicks', 'Total Sales Amount'].includes(item.title);
    }

    // By default, show all items
    return !['Total Sales Amount', 'Total Sales Count'].includes(item.title);
  }) || [];

  return (
    <>
      <div className='Overview_container'>
        <span className='main-headings-broadcast'>Overview</span>
      </div>

      {segments?.credit_blocked_count > 0 && (
        <Alert
          type="warning"
          showIcon
          message={`${segments.credit_blocked_count} contact${segments.credit_blocked_count > 1 ? 's were' : ' was'} skipped due to insufficient credits.`}
          style={{ marginTop: 12, marginBottom: 4 }}
        />
      )}

      <div className='postMain-container1 w-100  pt-20 flex-end space-between'>
        <div
          className=' flex-row space-between align-center '
          style={{ width: '100% ' }}
        >
          <div className='postMain  w-100 '>
            {filteredBroadcastList?.length > 0 && (
              <div className='broadCast-card flex-row space-between align-center '>
                {filteredBroadcastList.map((item, index) => (
                  <React.Fragment key={item?.id}>
                    <div className='flex-row space-between align-center '>
                      <div className='broadcastImage flex-row justify-center'>
                        <img src={item?.icon} alt='performance' />
                      </div>
                      <div
                        className='postCard-left flex-column  '
                        style={{ padding: '10px 10px' }}
                      >
                        <span className=''>{item?.title}</span>
                        <span className=''>{getStatusCount(item)}</span>
                      </div>
                    </div>

                    <div
                      className={` ${
                        filteredBroadcastList.length - 1 !== index
                          ? 'borderRight'
                          : ''
                      }`}
                    />
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SegmentOverview;
